'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024 from "./dev.cheleb.scalamigen.-Form$given_-Form_-String$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_ListElement$package$$anon$1$$anon$4() {
}
export { $c_Lsamples_ListElement$package$$anon$1$$anon$4 as $c_Lsamples_ListElement$package$$anon$1$$anon$4 };
$p = $c_Lsamples_ListElement$package$$anon$1$$anon$4.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ListElement$package$$anon$1$$anon$4;
/** @constructor */
function $h_Lsamples_ListElement$package$$anon$1$$anon$4() {
}
export { $h_Lsamples_ListElement$package$$anon$1$$anon$4 as $h_Lsamples_ListElement$package$$anon$1$$anon$4 };
$h_Lsamples_ListElement$package$$anon$1$$anon$4.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_dev$002echeleb$002escalamigen$002e$002dForm$0024given$005f$002dForm$005f$002dString$0024.$m_Ldev_cheleb_scalamigen_Form$given\uff3fForm\uff3fString$();
});
var $d_Lsamples_ListElement$package$$anon$1$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ListElement$package$$anon$1$$anon$4, "samples.ListElement$package$$anon$1$$anon$4", ({
  pi: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_ListElement$package$$anon$1$$anon$4 as $d_Lsamples_ListElement$package$$anon$1$$anon$4 };
